//- ==================================================
//- JavaScript: Widget
//- ==================================================

(function () {

  'use strict';

})();

function myMapWidget(selector,lat,lng,map_title) {
  var $container = $(selector);
  var $map = $container.find('[data-form="widget-map-obj"]');
  var latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
  var urlBase = '//' + location.hostname + (location.port ? ':' + location.port : '') + '/img/misc';
  var map;
  var marker;

  map = new google.maps.Map($map[0], {
    center: latlng,
    zoom: 15,
    streetViewControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP
    },
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP
    },
    scrollwheel: false,
    styles: [{
      'featureType': 'administrative',
      'elementType': 'labels.text.fill',
      'stylers': [{
        'color': '#444444'
      }]
    }, {
      'featureType': 'landscape',
      'elementType': 'all',
      'stylers': [{
        'color': '#f2f2f2'
      }]
    }, {
      'featureType': 'poi',
      'elementType': 'all',
      'stylers': [{
        'visibility': 'on'
      }]
    }, {
      'featureType': 'road',
      'elementType': 'all',
      'stylers': [{
        'saturation': -100
      }, {
        'lightness': 45
      }]
    }, {
      'featureType': 'road.highway',
      'elementType': 'all',
      'stylers': [{
        'visibility': 'simplified'
      }]
    }, {
      'featureType': 'road.arterial',
      'elementType': 'labels.icon',
      'stylers': [{
        'visibility': 'off'
      }]
    }, {
      'featureType': 'transit',
      'elementType': 'all',
      'stylers': [{
        'visibility': 'off'
      }]
    }, {
      'featureType': 'water',
      'elementType': 'all',
      'stylers': [{
        'color': '#c8cacb'
      }, {
        'visibility': 'on'
      }]
    }]
  });
  marker = new google.maps.Marker({
    position: latlng,
    map: map,
    title: map_title,
    icon: urlBase + '/pin-red.png',
    animation: google.maps.Animation.DROP,
  });
}
